import { GraphQLError } from "../../error/GraphQLError.mjs";

/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 */
export function KnownFragmentNamesRule(context) {
  return {
    FragmentSpread: function FragmentSpread(node) {
      var fragmentName = node.name.value;
      var fragment = context.getFragment(fragmentName);

      if (!fragment) {
        context.reportError(new GraphQLError("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
      }
    }
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/validation/rules/KnownFragmentNamesRule.mjs
// module id = px8S
// module chunks = 1